export default __webpack_public_path__ + "static/media/304.4dcda644.png";